<template>
	<form>
		<v-alert type="error" v-show="showMandatorAlert">
			{{ txt.mandatorAlert }}
		</v-alert>
		<ProgressBar :isLoading="loadingFilters" />
		<AlertBasic :show="showErrorAlert" type="error" :message="customErrorMessage" />
		<!-- Mandator -->
		<v-combobox
			v-show="mandatorVisbile"
			v-model="formState.selectedMandators"
			:items="formItems.mandator"
			:search-input.sync="searchMandators"
			hide-selected
			label="Mandator"
			multiple
			persistent-hint
			chips
			return-object
			:disabled="loadingFilters"
		/>
		<!-- Datepickers -->
		<v-row>
			<v-col cols="12" md="6">
				<v-menu
					ref="menuFrom"
					v-model="menuFrom"
					:close-on-content-click="true"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field v-model="formState.dateFrom" label="Date from" readonly v-on="on" />
					</template>
					<v-date-picker
						v-model="formState.dateFrom"
						no-title
						scrollable
						:first-day-of-week="1"
					/>
				</v-menu>
			</v-col>
			<v-col cols="12" md="6">
				<v-menu
					ref="menuTill"
					v-model="menuTill"
					:close-on-content-click="true"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field v-model="formState.dateTill" label="Date till" readonly v-on="on" />
					</template>
					<v-date-picker
						v-model="formState.dateTill"
						no-title
						scrollable
						:first-day-of-week="1"
					/>
				</v-menu>
			</v-col>
		</v-row>
		<!-- guestcard name  -->
		<v-combobox
			v-show="true"
			v-model="formState.selectedGuestcards"
			:items="formItems.guestcard"
			:search-input.sync="searchGuestcard"
			hide-selected label="Guest card name"
			multiple
			persistent-hint
			chips
			return-object
			:disabled="loadingFilters"
		/>
		<!-- Add value service  -->
		<v-combobox
			v-show="true"
			v-model="formState.selectedAddedservices"
			:items="formItems.addedservice"
			:search-input.sync="searchAddedservice"
			hide-selected
			label="Added value service"
			multiple
			persistent-hint
			chips
			return-object
			:disabled="loadingFilters"
		/>
		<!-- Serviceprovider  -->
		<v-combobox
			v-show="true"
			v-model="formState.selectedServiceproviders"
			:items="formItems.serviceprovider"
			:search-input.sync="searchServiceprovider"
			hide-selected
			label="Serviceprovider"
			multiple
			persistent-hint
			chips
			return-object
			:disabled="loadingFilters"
		/>
		<v-row>
			<v-col cols="12" md="6">
				<v-combobox
					v-show="true"
					v-model="formState.selectedProductName"
					:items="formItems.productName"
					hide-selected
					label="Product Name"
					multiple
					persistent-hint
					chips
					return-object
					:disabled="loadingFilters"
				/>
			</v-col>
			<!-- Product SKU  -->
			<v-col cols="12" md="6">
				<v-combobox
					v-show="true"
					v-model="formState.selectedProductSku"
					:items="formItems.productSku"
					hide-selected
					label="Product SKU"
					multiple
					persistent-hint
					chips
					return-object
					:disabled="loadingFilters"
				/>
			</v-col>
		</v-row>

		<v-btn class="primary" style="margin:10px" @click="submitFilters" :disabled="loadingFilters">
			{{ txt.searchBtn }}
		</v-btn>
		<v-btn style="margin:10px" @click="exportExcelData" :disabled="loadingFilters">
			{{ txt.exportExcelDataBtn }}
		</v-btn>
		<v-btn style="margin:10px" @click="exportCsvData" :disabled="loadingFilters">
			{{ txt.exportCsvDataBtn }}
		</v-btn>

	</form>
</template>

<script>
import axios from 'axios'
import ProgressBar from '../vueBasics/Progressbar.vue'
import AlertBasic from '../vueBasics/AlertBasic.vue'

export default {
	name: 'ReportingsystemFilter',
	props: {
		approvedMandators: {
			type: Array,
			default: () => [],
		},
		appNameShort: {
			type: String,
			default: 'gc',
		},
		loadingGuestcardData: {
			type: Boolean,
			default: false,
		},
		errorDataLoading: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ProgressBar,
		AlertBasic,
	},
	data() {
		return {
			formState: {
				selectedMandators: [],
				dateFrom: new Date().toISOString().substr(0, 10),
				dateTill: new Date().toISOString().substr(0, 10),
				selectedGuestcards: [],
				selectedAddedservices: [],
				selectedServiceproviders: [],
				selectedProductSku: [],
				selectedProductName: [],
			},
			formItems: {
				mandator: ['Mandators could not be loaded'],
				guestcard: ['Please select a mandator.'],
				addedservice: ['Value added services could not be loaded'],
				serviceprovider: ['Serviceproviders could not be loaded'],
				productSku: ['Product SKUs could not be loaded'],
				productName: ['Product names could not be loaded'],
			},
			txt: {
				searchBtn: 'Show Data',
				exportExcelDataBtn: 'Excel Export',
				exportCsvDataBtn: 'CSV Export',
				mandatorAlert: 'Please select at least one mandator.',
			},
			loading: {
				mandator: false,
				guestcard: false,
				addedservice: false,
				serviceprovider: false,
				productSku: false,
				productName: false,
			},
			error: {
				guestcard: false,
				mandator: false,
				addedservice: false,
				serviceprovider: false,
				productSku: false,
				productName: false,
			},
			// vars for datepickers
			menuFrom: false,
			menuTill: false,
			modal: false,
			// Autocomplete
			searchMandators: null,
			searchGuestcard: null,
			searchAddedservice: null,
			searchServiceprovider: null,
			noResult: false,
			showFilterData: false,
			mandatorVisbile: true,
			appName: this.appNameShort,
			showMandatorAlert: false,
		}
	},
	watch: {
		'formState.dateFrom': {
			handler() {
				this.setTillTime()
			},
		},
		'formItems.mandator': {
			handler() {
				this.mandatorAutofill()
			},
		},
		'formState.selectedMandators': {
			handler() {
				this.shiftMandators()
				this.clearFormItems()
				this.getServiceprovider(this.formState.selectedMandators)
				this.getGuestcardName(this.formState.selectedMandators)
				this.getAddedValueServices(this.formState.selectedMandators)
				this.getProductSkusAndNames(this.formState.selectedMandators)
			},
		},
	},
	methods: {
		async getMandators() {
			try {
				// eslint-disable-next-line no-undef
				const r = await axios.get(`${config.baseAPIurl}/guestcard/mandator?appNameShort=gc`)
				this.$data.formItems.mandator = r.data
			} catch (e) {
				console.log(e)
			}
		},
		clearFormItems() {
			const mandators = this.formItems.mandator
			this.formItems = {
				guestcard: ['Please select a mandator.'],
				addedservice: ['Value added services could not be loaded'],
				serviceprovider: ['Serviceproviders could not be loaded'],
				productSku: ['Product SKUs could not be loaded'],
				productName: ['Product names could not be loaded'],
				mandator: mandators,
			}
		},
		mandatorAutofill() {
			if (this.formItems.mandator.length === 1) {
				this.formState.selectedMandators = this.formItems.mandator
				this.mandatorVisbile = false
			}
		},
		async getServiceprovider(selectedMandators) {
			if (selectedMandators.length == 0) {
				this.$data.formItems.serviceprovider = ['Please select a mandator.']
				return
			}
			this.loading.serviceprovider = true
			try {
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/guestcard/service-provider?installationid=${selectedMandators[0].value}`)
				this.$data.formItems.serviceprovider = r.data
			} catch (err) {
				this.error.serviceprovider = true
				setTimeout(() => {
					this.error.serviceprovider = false
				}, 5000)
			}
			this.loading.serviceprovider = false
		},
		async getGuestcardName(selectedMandators) {
			if (selectedMandators.length == 0) {
				this.$data.formItems.guestcard = ['Please select a mandator.']
				return
			}
			this.loading.guestcard = true
			try {
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/guestcard/guestcard-name?installationid=${selectedMandators[0].value}`)
				this.$data.formItems.guestcard = r.data
			} catch (err) {
				this.error.guestcard = true
				setTimeout(() => {
					this.error.guestcard = false
				}, 5000)
			}
			this.loading.guestcard = false
		},
		async getAddedValueServices(selectedMandators) {
			if (selectedMandators.length == 0) {
				this.$data.formItems.addedservice = ['Please select a mandator.']
				return
			}
			this.loading.addedservice = true
			try {
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/guestcard/added-value?installationid=${selectedMandators[0].value}`)
				this.$data.formItems.addedservice = r.data
			} catch (err) {
				this.error.addedservice = true
				setTimeout(() => {
					this.error.addedservice = false
				}, 5000)
			}
			this.loading.addedservice = false
		},
		async getProductSkusAndNames(selectedMandators) {
			if (selectedMandators.length == 0) {
				this.$data.formItems.productSku = ['Please select a mandator.']
				return
			}
			this.loading.productSku = true
			try {
				// eslint-disable-next-line max-len,  no-undef
				const r = await axios.get(`${config.baseAPIurl}/guestcard/product-sku-name?installationid=${selectedMandators[0].value}`)
				this.$data.formItems.productSku = r.data.productSku
				this.$data.formItems.productName = r.data.productNames
			} catch (err) {
				this.error.productSku = true
				setTimeout(() => {
					this.error.productSku = false
				}, 5000)
			}
			this.loading.productSku = false
		},
		submitFilters() {
			if (this.formState.selectedMandators.length == 0) {
				this.showMandatorAlert = true
				return
			}
			this.showMandatorAlert = false
			const filterData = {
				mandator: this.formState.selectedMandators,
				dateFrom: this.formState.dateFrom,
				dateTill: this.formState.dateTill,
				guestcards: this.formState.selectedGuestcards,
				addedservices: this.formState.selectedAddedservices,
				serviceprovider: this.formState.selectedServiceproviders,
				productnames: this.formState.selectedProductName,
				productsku: this.formState.selectedProductSku,
			}
			this.selectedFilters = filterData
			this.$emit('submit', filterData)
		},
		exportExcelData() {
			if (this.formState.selectedMandators.length == 0) {
				this.showMandatorAlert = true
				return
			}
			this.showMandatorAlert = false
			const filterData = {
				mandator: this.formState.selectedMandators,
				dateFrom: this.formState.dateFrom,
				dateTill: this.formState.dateTill,
				guestcards: this.formState.selectedGuestcards,
				addedservices: this.formState.selectedAddedservices,
				serviceprovider: this.formState.selectedServiceproviders,
				productnames: this.formState.selectedProductName,
				productsku: this.formState.selectedProductSku,
			}
			this.$emit('exceldataexport', filterData)
		},
		exportCsvData() {
			if (this.formState.selectedMandators.length == 0) {
				this.showMandatorAlert = true
				return
			}
			this.showMandatorAlert = false
			const filterData = {
				mandator: this.formState.selectedMandators,
				dateFrom: this.formState.dateFrom,
				dateTill: this.formState.dateTill,
				guestcards: this.formState.selectedGuestcards,
				addedservices: this.formState.selectedAddedservices,
				serviceprovider: this.formState.selectedServiceproviders,
				productnames: this.formState.selectedProductName,
				productsku: this.formState.selectedProductSku,
			}
			this.$emit('csvdataexport', filterData)
		},
		setTillTime() {
			if (this.formState.dateTill < this.formState.dateFrom) this.formState.dateTill = this.formState.dateFrom
			return this.formState.dateTill
		},
		shiftMandators() {
			if (this.formState.selectedMandators.length > 1) {
				this.formState.selectedMandators.shift()
			}
		},
	},
	computed: {
		loadingFilters() {
			return this.loading.guestcard || this.loading.addedservice || this.loading.serviceprovider || this.loading.productSku || this.loading.productName || this.loadingGuestcardData
		},
		showErrorAlert() {
			return this.error.guestcard || this.error.addedservice || this.error.serviceprovider || this.error.productSku || this.error.productName || this.errorDataLoading
		},
		customErrorMessage() {
			if (this.errorDataLoading) return 'Error at loading the data'
			return 'Error at loading the filters'
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators()
			this.getServiceprovider(this.formState.selectedMandators)
		})
	},
}
</script>

<style scoped>
form {
  padding: 60px 60px 0px 30px;
}
.searchButton {
  color: #00a0e3;
}
</style>
